import { useState } from "react";
import { PlayCircle } from "lucide-react";

const embed = (url) => {
  const yt = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/.exec(url);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = /vimeo\.com\/(?:video\/)?(\d+)/.exec(url);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return url;
};

const Frame = ({ children, caption, testId }) => (
  <figure className="overflow-hidden rounded-xl border border-slate-200 bg-slate-50 shadow-sm" data-testid={testId}>
    {children}
    <figcaption className="flex items-center gap-1.5 px-4 py-2 text-xs text-slate-400">{caption}</figcaption>
  </figure>
);

export const SectionMedia = ({ s }) => {
  const [shot, setShot] = useState(true);
  const [video, setVideo] = useState(true);
  const external = s.video && /^https?:\/\//.test(s.video);
  if (!shot && !video && !external) return null;
  return (
    <div className={`mb-6 grid gap-4 ${shot && (video || external) ? "lg:grid-cols-2" : ""}`} data-testid="manual-media">
      {shot && (
        <Frame caption={`Schermata della sezione ${s.title}`} testId="manual-screenshot">
          <img src={`/manual/${s.id}.jpg`} alt={`Schermata: ${s.title}`} onError={() => setShot(false)} className="w-full" loading="lazy" />
        </Frame>
      )}
      {external ? (
        <Frame caption={<><PlayCircle className="h-3.5 w-3.5" />Video guida</>} testId="manual-video-external">
          <div className="aspect-video"><iframe src={embed(s.video)} title={`Video guida: ${s.title}`} className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture" allowFullScreen /></div>
        </Frame>
      ) : video && (
        <Frame caption={<><PlayCircle className="h-3.5 w-3.5" />Video guida: come si usa la sezione (senza audio)</>} testId="manual-video">
          <video poster={`/manual/${s.id}.jpg`} controls muted playsInline preload="metadata" className="aspect-[16/10] w-full bg-slate-900" data-testid="manual-video-player">
            <source src={`/manual/${s.id}.mp4`} type="video/mp4" />
            <source src={`/manual/${s.id}.webm`} type="video/webm" onError={() => setVideo(false)} />
          </video>
        </Frame>
      )}
    </div>
  );
};
